document.querySelectorAll('tab-modal .card__heading').forEach(function(heading) {
    const p = document.createElement('p');

    // Copy class and content
    p.className = heading.className;
    p.innerHTML = heading.innerHTML;

    // Replace h3 with p
    heading.parentNode.replaceChild(p, heading);
});

document.addEventListener("DOMContentLoaded", function () {
    const contactForm = document.getElementById("ContactForm");

    if (contactForm) {
        contactForm.addEventListener("submit", function () {

            // Wait for Shopify form submission
            setTimeout(function () {

                // Check success message
                const successMessage = document.querySelector(".form-status");

                if (successMessage) {
                    window.location.href = "/pages/thank-you";
                }

            }, 1000);

        });
    }
});

// Canonical for targeted page

document.addEventListener("DOMContentLoaded", function () {

    const canonicalMappings = {
        "/collections/costumes/hats": "https://www.morethanparty.com.au/collections/hats",
        "/collections/costumes/wigs": "https://www.morethanparty.com.au/collections/wigs",
        "/collections/costumes/props": "https://www.morethanparty.com.au/collections/props",
        "/collections/costumes/facial-hair": "https://www.morethanparty.com.au/collections/facial-hair",
        "/collections/party-essentials/streamers": "https://www.morethanparty.com.au/collections/streamers",
        "/collections/party-essentials/glow-sticks": "https://www.morethanparty.com.au/collections/glow-sticks",
        "/collections/party-essentials/confetti": "https://www.morethanparty.com.au/collections/confetti",
        "/collections/themed-party/hens-night": "https://www.morethanparty.com.au/collections/hens-night"
    };

    const currentPath = window.location.pathname.replace(/\/$/, '');

    if (canonicalMappings[currentPath]) {

        let canonicalTag = document.querySelector('link[rel="canonical"]');

        if (!canonicalTag) {
            canonicalTag = document.createElement('link');
            canonicalTag.setAttribute('rel', 'canonical');
            document.head.appendChild(canonicalTag);
        }

        canonicalTag.setAttribute('href', canonicalMappings[currentPath]);
    }
});
